import { z } from 'zod'
import { InterestDirection } from '../../enums/interest-direction.enum'

export const updateDepositSchema = z.object({
  name: z.string().min(2).max(100).optional(),
  interestRate: z.number().positive().max(100).optional(),
  nextInterestAmount: z.number().nonnegative().optional(),
  targetAccountId: z.string().guid().optional(),
  incomeCategoryId: z.string().guid().optional(),
  interestDirection: z.nativeEnum(InterestDirection).optional(),
})

export type UpdateDepositDto = z.infer<typeof updateDepositSchema>
